import { Instance, SnapshotOut, types } from "mobx-state-tree";
import {
  AuthInfo,
  IAuthInfo
} from "../../models/auth-info/AuthInfo";
import {
  AuthInfoApi,
  TGetAuthInfoResult,
  TGetAuthInfosResult, TUpdateAuthInfoResult
} from "../../services";
import { withEnvironment } from "../extensions/with-environment";
import { withRootStore } from "../extensions/with-root-store";
import { defaultPagination, withPagination } from "../extensions/withPagination";
import { withSetPropAction } from '../extensions/withSetPropAction';

/**
 * # AuthInfoStore
 * 
 * AuthInfoStore을 설명하세요.
 */
export const AuthInfoStore = types
  .model("AuthInfoStore")
  // --------------------------------------------------------------------------
  .props({
    authInfoList : types.optional(types.array(AuthInfo), []),
    authInfo : types.optional(AuthInfo, {}),
    authYn: types.maybeNull(types.optional(types.boolean, false))
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withPagination)
  .actions(withSetPropAction)
  // eslint-disable-line @typescript-eslint/no-unused-vars
  .views((self) => ({}))
  // --------------------------------------------------------------------------
  // MUTATEs - 모델 상태를 변경
  .actions((self) => ({
    /**
     * authInfos을 교체
     *
     * @param `authInfos` 새로운 모델의 배열
     */
    setAuthInfoList: (authInfoList: IAuthInfo[]) => {
      self.authInfoList.replace(authInfoList);
    },

    setAuthInfo: (authInfo: IAuthInfo) => {
      self.authInfo = authInfo;
    },

  }))
  // --------------------------------------------------------------------------
  // REQUESTs - 서비스 요청 및 기타 인터페이스 요청 
  .actions((self) => ({
    /**
     * 전체 목록을 Api를 통해 조회
     * 
     * 조회한 결과로 AuthInfos를 교체한다. 실패시 에러 로그를 남긴다.
     */
    getAuthInfoList: async () => {
      try{
        const authInfoApi : AuthInfoApi = new AuthInfoApi(self.environment.api);
        const result: TGetAuthInfosResult = await authInfoApi.getAuthInfoList(self.pagination);
        if (self.rootStore.responseStore.getResponseResult(result)) {
          if(result.authInfoList && result.pagination){
            self.setAuthInfoList(result.authInfoList);
            self.setPagination(result.pagination);
          } else if(!result.pagination){
            self.setPagination(defaultPagination);
          }
        } 
      } catch(e) {
        self.rootStore.responseStore.errorProcessing(e);
      }
    },

    getAuthInfo : async (userSid:number) => {
      try {
        const authInfoApi :  AuthInfoApi = new AuthInfoApi(self.environment.api);
        const result: TGetAuthInfoResult = await authInfoApi.getAuthInfo(userSid);
        
        if (self.rootStore.responseStore.getResponseResult(result)) {
          if (result.authInfo) {
            self.setAuthInfo(result.authInfo);
          }
        }
      }catch(e){
        self.rootStore.responseStore.errorProcessing(e);
      }
    },

    updateAuthInfo : async (userSid:number, authInfo :any) => {
      try {
        const authInfoApi :  AuthInfoApi = new AuthInfoApi(self.environment.api);
        const result: TUpdateAuthInfoResult = await authInfoApi.updateAuthInfo(userSid, authInfo);
        
        if (self.rootStore.responseStore.getResponseResult(result)) {
          if (result.authInfo) {
            self.setAuthInfo(result.authInfo);
          }
        }
      }catch(e){
        self.rootStore.responseStore.errorProcessing(e);
      }

    }
  }))

// --------------------------------------------------------------------------
type TAuthInfoStore = Instance<typeof AuthInfoStore>;
type TAuthInfoStoreSnapshot = SnapshotOut<typeof AuthInfoStore>

export interface IAuthInfoStore extends TAuthInfoStore {}
export type TAuthInfoStoreKeys = keyof TAuthInfoStoreSnapshot & string;
export interface IAuthInfoStoreSnapshot extends TAuthInfoStoreSnapshot {}
export const createAuthInfoStore = () => 
  types.optional(AuthInfoStore, {} as TAuthInfoStore);
